const SET_LIST = (state, obj) => {
  state.list = obj
}

export default {
  SET_LIST
}



// WEBPACK FOOTER //
// ./src/features/banks/store/mutations.js